import { useEffect } from "react";
import { SITE } from "../siteConfig";

export default function Seo({ title, description, path, image = SITE.image, type = "website", noindex = false, jsonLd }) {
  const canonical = path ? new URL(path, SITE.url).toString() : null;
  const absoluteImage = image?.startsWith("http") ? image : new URL(image, SITE.url).toString();
  const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  useEffect(() => {
    document.querySelectorAll('[data-static-seo="true"]').forEach((node) => node.remove());
  }, []);

  return (
    <>
      <title>{title}</title>
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={absoluteImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Mangalam Group — Industrial and Mining Tyre Solutions" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={absoluteImage} />
      {schemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </>
  );
}
